import "./setupAxios"; // no exports; just runs the config
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import { ThemeProvider } from '@emotion/react';
// import theme from './theme';
import './index.css';  // <-- add this line

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <ThemeProvider theme={theme}> */}
      <App />
    {/* </ThemeProvider> */}
    
  </React.StrictMode>
);
